
import { Button } from '../../../components/base/Button';

export const HeroSection = () => {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/005eb02eca31b17134fdaaa69e0c0fdc.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-blue-900/60"></div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          {/* Badge */}
          <div className="inline-flex items-center bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-plant-line mr-2"></i>
            Marine Bio Technology Leader
          </div>
          
          {/* Main Title */}
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Advanced Marine Biotechnology
            <br />
            <span className="text-cyan-300">For Sustainable Future</span>
          </h1>
          
          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-3xl mx-auto leading-relaxed">
            Developing innovative eco-friendly solutions with marine nano fiber technology<br />
            for a cleaner and safer world
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button variant="primary" size="lg" className="bg-cyan-500 hover:bg-cyan-600 text-white">
              <i className="ri-microscope-line mr-2"></i>
              Explore Technology
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-blue-900">
              <i className="ri-phone-line mr-2"></i>
              Contact Us
            </Button>
          </div>
          
          {/* Innovation Badge */}
          <div className="mt-12 flex justify-center">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg px-6 py-3">
              <p className="text-sm font-medium text-cyan-300 mb-1">GLOBAL PIONEER</p>
              <p className="text-lg font-bold">IN MARINE BIOTECHNOLOGY</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
};
